module.exports = __webpack_public_path__ + "img/fb.16ec4047.png";